import { E as EmblaCarousel } from './embla-carousel.esm-DpJzJcqm.js';
import { W as WheelGesturesPlugin } from './embla-carousel-wheel-gestures.esm-BSvTFWB9.js';

class PredictiveSearchSuggestions extends HTMLElement {
  #viewport = this.querySelector('.embla__viewport');
  /** @type {import('embla-carousel').EmblaCarouselType} */
  #embla;

  connectedCallback() {
    this.#initCarousel();
  }

  disconnectedCallback() {
    this.#embla?.destroy();
  }

  /**
   * Initialize the horizontal search-suggestion strip. Slide width is
   * content-driven via CSS; mouse-wheel scrolling releases at the edges.
   */
  #initCarousel() {
    if (!this.#viewport) return;

    this.#embla = EmblaCarousel(this.#viewport, { align: 'start', skipSnaps: true }, [
      WheelGesturesPlugin(),
    ]);
  }
}

customElements.define('predictive-search-suggestions', PredictiveSearchSuggestions);
